module.exports = __webpack_public_path__ + "img/132x132_sale@2x.426380e6.png";